<button type="button" class="btn btn-success disabled sm-cursor-grab" i18n>Sign manually</button>
